import { GET_STORES_SUCCESS } from "./constants";
import produce from "immer";

// The initial state of this store.
const initialState = {
    stores: [],
};

export default produce((state, action) => {
    switch (action.type) {
        case GET_STORES_SUCCESS: {
            state.stores = action.stores;
            break;
        }
        default:
            break;
    }
}, initialState);
